import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { ADMININTERMEDIARY_INIT_LOADING, ADMININTERMEDIARY_INIT_SUCCESS, ADMININTERMEDIARY_INIT_FAIL, ADMININTERMEDIARY_INTERGROUPLIST, ADMININTERMEDIARY_MENU_INIT_LOADING, ADMININTERMEDIARY_MENU_INIT_SUCCESS, ADMININTERMEDIARY_MENU_INIT_FAIL, ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU, ADMININTERMEDIARY_INTERCOMMDISCFACT, ADMININTERMEDIARY_INTERCOMMDISCFACTORLIST } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'
const state = {
  init: 0,
  initErr: [],
  interGroupList: [],
  menu: {},
  intermediary: {
    init: 0,
    initErr: [],
    menu: {},
    inter: undefined,
    intermediaryName: undefined,
    dateOpened: undefined,
    dateClosed: undefined,
    interGroupCode: undefined,
    interGroupName: undefined,
    add1: undefined,
    add2: undefined,
    add3: undefined,
    add4: undefined,
    postalCode: undefined,
    suspended: undefined,
    interCommDiscFactorTabMenu: 0,
    interCommDiscFactorDisplayFactReviewTab: false,
    interCommDiscFactorDisplayRateTab: false,
    interCommDiscFactorProduct: undefined,
    interCommDiscFactorEffDate: undefined,
    interCommDiscFactors: {
      fact1: null,
      fact2: null,
      fact3: null,
      fact4: null,
      fact5: null,
      fact6: null
    },
    appIDList: [],
    factor1to3List: [],
    factor4to6List: [],
    interCommDiscFactorProductAppId: undefined
  }
}

const getters = {
}

const mutations = {
  [ADMININTERMEDIARY_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [ADMININTERMEDIARY_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [ADMININTERMEDIARY_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [ADMININTERMEDIARY_INTERGROUPLIST](state, data) {
    Vue.set(state, 'interGroupList', data)
  },
  [ADMININTERMEDIARY_MENU_INIT_LOADING](state) {
    resetProfile(state)
  },
  [ADMININTERMEDIARY_MENU_INIT_SUCCESS](state, data) {
    // Update menu
    state.intermediary.init = 1
    state.intermediary.initErr = []
    state.intermediary.menu = data.menu
    // data

    state.intermediary.inter = data.data.inter
    state.intermediary.intermediaryName = data.data.name
    state.intermediary.dateOpened = data.data.dateOpened
    state.intermediary.dateClosed = data.data.dateClosed
    state.intermediary.interGroupCode = data.data.interGroupCode
    state.intermediary.interGroupName = data.data.interGroupName
    state.intermediary.officeNo = data.data.officeNo
    state.intermediary.faxNo = data.data.faxNo
    state.intermediary.add1 = data.data.add1
    state.intermediary.add2 = data.data.add2
    state.intermediary.add3 = data.data.add3
    state.intermediary.add4 = data.data.add4
    state.intermediary.postalCode = data.data.postalCode
    state.intermediary.suspended = data.data.suspended

    state.intermediary.appIDList = data.appIDList
  },
  [ADMININTERMEDIARY_MENU_INIT_FAIL](state, error) {
    state.intermediary.init = 2
    state.intermediary.initErr = error
    state.intermediary.menu = {}

    state.intermediary.appIDList = []
  },
  [ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU](state, data) {
    state.intermediary.interCommDiscFactorTabMenu = data.interCommDiscFactTab
    state.intermediary.interCommDiscFactorDisplayFactReviewTab = data.displayFactReviewTab
    state.intermediary.interCommDiscFactorDisplayRateTab = data.displayRateTab
    if (data.product) {
      state.intermediary.interCommDiscFactorProduct = data.product
    }
    if (data.effDate) {
      state.intermediary.interCommDiscFactorEffDate = data.effDate
    }
  },
  [ADMININTERMEDIARY_INTERCOMMDISCFACT](state, data) {
    if (data) {
      state.intermediary.interCommDiscFactors = data
    }
  },
  [ADMININTERMEDIARY_INTERCOMMDISCFACTORLIST](state, data) {
    if (data) {
      state.intermediary.factor1to3List = data.factor1to3List
      state.intermediary.factor4to6List = data.factor4to6List
      state.intermediary.interCommDiscFactorProductAppId = data.appId
    }
  }
}

const actions = {
  async interManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.interManagement
    commit(ADMININTERMEDIARY_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(ADMININTERMEDIARY_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMININTERMEDIARY_INIT_FAIL, extractMessages(error))
    }
  },
  async interMenuInit({ commit, state }, inter) {
    commit(ADMININTERMEDIARY_MENU_INIT_LOADING)
    try {
      const apiURI = state.menu.interGet
      const expand = {
        inter: inter
      }
      const result = await http.get(expandURI(apiURI, expand))
      const menu = extractMenu(result.data._links)
      const commitResult = {
        data: result.data.data.inter,
        appIDList: result.data.data.appIDList,
        menu: menu
      }
      commit(ADMININTERMEDIARY_MENU_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMININTERMEDIARY_MENU_INIT_FAIL, extractMessages(error))
    }
  }
}
const resetProfile = (state) => {
  state.intermediary.init = 0
  state.intermediary.initErr = []
  state.intermediary.intermediaryName = undefined
  state.intermediary.dateOpened = undefined
  state.intermediary.dateClosed = undefined
  state.intermediary.interGroupCode = undefined
  state.intermediary.interGroupName = undefined
  state.intermediary.add1 = undefined
  state.intermediary.add2 = undefined
  state.intermediary.add3 = undefined
  state.intermediary.add4 = undefined
  state.intermediary.postalCode = undefined
  state.intermediary.suspended = undefined
  state.intermediary.interProductId = undefined
}

export default {
  state,
  getters,
  mutations,
  actions
}
